import { Component, OnInit } from '@angular/core';
import { ShopSettingsService } from 'src/app/modules/general/services/shop-settings.service';
import { BookingStepEnum } from '../../models/booking-step.enum';
import { BookingStepService } from '../../services/booking-step.service';

@Component({
  selector: 'app-booking-authentication',
  templateUrl: './booking-authentication.component.html',
  styleUrls: ['./booking-authentication.component.css']
})
export class BookingAuthenticationComponent implements OnInit {

  hideNavigation = true;

  constructor(
    private bookingStepService: BookingStepService,
    private shopSettingsService: ShopSettingsService,
  ) {
  }

  ngOnInit(): void {
  }

  onBack(): void {
    this.bookingStepService.back();
  }

  loggedIn(): void {
    this.bookingStepService.authorizationAsGuest = false;
    this.bookingStepService.forward();
  }

  onNavigationVisibilityChange(showNavigationBack: boolean): void {
    this.hideNavigation = !showNavigationBack;
  }

  registerAsGuest(): void {
    this.bookingStepService.authorizationAsGuest = false;
    this.bookingStepService.update(
      BookingStepEnum.RegisterAsGuest
    );
  }

  authorizationAsGuest(): void {
    this.bookingStepService.authorizationAsGuest = true;
    this.bookingStepService.forward();
  }

  get allowGuestSale(): boolean {
    return this.shopSettingsService?.shopSettings?.allowGuestSale;
  }
}
